export const TOKEN_TYPE: string = "Bearer";
export const REQUEST_HEADER_AUTH_KEY: string = "Authorization";
